<template>
    <v-row no-gutters class="mb-1">
        <v-col cols="12" md="6" class="pe-1">
            <v-autocomplete
                label="Item"
                v-model="line.item_id"
                outlined
                dense
                :items="items"
                item-text="display_name"
                item-value="id"
                @update:search-input="$emit('update:item-search-input', $event)"
                @change="handleItemChange"
                hide-details="auto">
            </v-autocomplete>
        </v-col>
        <v-col cols="12" md="3" class="pe-1">
            <v-text-field
                label="Quantity"
                v-model="line.quantity"
                outlined
                dense
                hide-details="auto">
            </v-text-field>
        </v-col>
        <v-col cols="12" md="3" class="d-flex align-center">
            <v-autocomplete
                label="Unit"
                v-model="line.measure_unit_id"
                dense
                :items="measureUnits"
                item-text="name"
                item-value="id"
                outlined
                hide-details="auto">
            </v-autocomplete>
            <v-btn icon @click="$emit('delete:line')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        items: Array,
        value: Object
    },
    data() {
        return {
            line: {}
        }
    },
    watch: {
        line: {
            deep: true,
            handler(line) {
                this.$emit("input", {...line})
            }
        }
    },
    computed: {
        item() {
            return this.items.find(each => each.id == this.line.item_id)
        },
        measureUnits() {
            if(!this.item) return [];
            if(!Array.isArray(this.item.measure_units)) return [];
            return this.item.measure_units;
        }
    },
    methods: {
        handleItemChange() {
            this.line.measure_unit_id = null;
        }
    },
    created() {
        if(this.value) {
            this.line = {...this.value}
        }
    }
}
</script>

<style>

</style>